import { createAction } from '@ngrx/store';

const actionDesc = '[App]';

export const initApp = createAction(`${actionDesc} - Init App`);
export const appInitialized = createAction(`${actionDesc} - App Initialized`);
export const appResume = createAction(`${actionDesc} - App Resume`);

export const dismissAllModals = createAction(`${actionDesc} - Dismiss All Modals`);
